import {
  Checkbox,
  Input,
  message,
  Popover,
  Segmented,
  Table,
  // Button,
  Popconfirm,
  Descriptions,
  Flex,
  Spin,
  Result,
} from "antd";
import { FC, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import FormInput from "../../../form-components/InputComponent";
import FormDatePicker from "../../../form-components/DatePicker";
import dayjs from "dayjs";
import {
  Modal,
  ModalBody,
  Col,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Alert,
} from "reactstrap";
import FormTimePicker from "../../../form-components/FormTimePickerProps";
import { LoadingOutlined } from "@ant-design/icons";
import { nanoid } from "@reduxjs/toolkit";
import { calendarApis } from "../../../../api/Calendar";
import { ApiResponse } from "../../../../api/master/axiosIndex";
import Swal from "sweetalert2";
import { ReactTyped } from "react-typed";
import { Icon } from "../../../../components/Component";
import { ViewAccess } from "../../../../components/accessControl/AccessControl";

const CalendarView: FC<{ fullData: any; refresh: () => void }> = ({
  fullData,
  refresh,
}) => {
  console.log("calendarData", fullData);
  const [loading, setLoading] = useState(true);
  const [isViewMode, setIsViewMode] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false); // Force initial state to false
  // const [isDirty, setIsDirty] = useState(false);
  const [selectedDays, setSelectedDays] = useState<any>([]);
  const [originalSelectedDays, setOriginalSelectedDays] = useState<string[]>(
    []
  );
  const [pagination, setPagination] = useState({
    pageSize: 5,
    pageSizeOptions: ["5", "10", "20", "30", "40", "50"],
    showSizeChanger: true,
  });
  const [shifts, setShifts] = useState<any[]>([]);
  const [originalShifts, setOriginalShifts] = useState<string[]>([]);
  const [selectedShifts, setSelectedShifts] = useState<string[]>([]);
  const [newShiftName, setNewShiftName] = useState("");
  const [popoverVisible, setPopoverVisible] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [holidayName, setHolidayName] = useState("");
  const [dateRange, setDateRange] = useState<any>(null);
  const [selectedHolidayId, setSelectedHolidayId] = useState(null);
  const [selectedHoliday, setSelectedHoliday] = useState<any>(null);
  const [holidays, setHolidays] = useState<any>([]);

  const [warning, setWarning] = useState<{
    error: any | undefined;
    message: string | undefined;
  }>({
    error: undefined,
    message: undefined,
  });

  const [holidayState, setHolidayState] = useState({
    newLines: [],
    updatedLines: [],
    deletedLines: [],
    existing: [], // for display or tracking original list
  });

  const initalData = {
    calendarTitle: fullData?.calendarTitle,
    calendarStartDate: fullData?.calendarStartDate,
    calendarEndDate: fullData?.calendarEndDate,
    calendarWorkingDays: [],
    calendarHolidays: fullData?.calendarHolidays || [],
  };
  const formMethods = useForm<any>({
    mode: "onChange",
    defaultValues: initalData,
  });

  const {
    watch,
    handleSubmit,
    control,
    getValues,
    reset,
    formState: { isDirty: formIsDirty, dirtyFields },
  } = formMethods;

  useEffect(() => {
    if (fullData) {
      // alert("fullData");
      setIsEditMode(false);
      setLoading(false);
      formMethods.reset({
        calendarTitle: fullData.calendarTitle,
        calendarStartDate: dayjs(new Date(fullData?.calendarStartDate)),
        calendarEndDate: dayjs(new Date(fullData?.calendarEndDate)),
        calendarWorkingDays: fullData.calendarWorkingDays,
        calendarHolidays: fullData.calendarHolidays || [],
      });
      // Extract selected day names
      const selected =
        fullData?.calendarWorkingDays?.map((day: any) => day.dayName) || [];
      setSelectedDays(selected);
      setOriginalSelectedDays(selected);

      const shiftList =
        fullData?.calendarShifts?.map((s: any) => ({
          name: s.shiftName,
          shiftStartTime: s.shiftStartTime,
          shiftEndTime: s.shiftEndTime,
          shiftId: s.shiftId,
          shiftType: s.shiftType,
        })) || [];

      setShifts(shiftList);
      setOriginalShifts(shiftList);
      setSelectedShifts(shiftList.map((s: any) => s.name));
      setHolidayState({
        existing: fullData.calendarHolidays || [],
        newLines: [],
        updatedLines: [],
        deletedLines: [],
      });

      setHolidays([...(fullData.calendarHolidays || [])]);
    }
  }, [fullData, reset]);

  useEffect(() => {
    console.log("holidayState", holidayState);
    const combinedHolidays = [
      ...holidayState.existing.filter(
        (e: any) =>
          !holidayState.updatedLines.some(
            (u: any) => u.holidayId === e.holidayId
          )
      ),
      ...holidayState.updatedLines,
      ...holidayState.newLines,
    ];
    console.log("combinedHolidays", combinedHolidays);
    setHolidays(combinedHolidays);
  }, [holidayState]);

  useEffect(() => {
    if (isEditMode && shifts.length > 0) {
      shifts.forEach((shift) => {
        const name = shift.name || shift.shiftName;
        if (shift.shiftStartTime) {
          formMethods.setValue(
            `startTime-${name}`,
            dayjs(shift.shiftStartTime, "HH:mm")
          );
        }
        if (shift.shiftEndTime) {
          formMethods.setValue(
            `endTime-${name}`,
            dayjs(shift.shiftEndTime, "HH:mm")
          );
        }
      });
    }
  }, [isEditMode, shifts]);

  // useEffect(() => {
  //   setIsDirty(formIsDirty);
  // }, [formIsDirty]);

  const daysMaster = [
    { dayId: 1, dayName: "Sunday" },
    { dayId: 2, dayName: "Monday" },
    { dayId: 3, dayName: "Tuesday" },
    { dayId: 4, dayName: "Wednesday" },
    { dayId: 5, dayName: "Thursday" },
    { dayId: 6, dayName: "Friday" },
    { dayId: 7, dayName: "Saturday" },
  ];

  const toggleSelection = (value: string | string[]) => {
    const newValue = Array.isArray(value) ? value[0] : value;

    setSelectedDays(
      (prev: any) =>
        prev.includes(newValue)
          ? prev.filter((d: any) => d !== newValue) // unselect
          : [...prev, newValue] // select
    );
    formMethods.setValue("calendarWorkingDays", selectedDays, {
      shouldDirty: true, // ✅ mark field as dirty
    });
  };

  const prepareCalendarWorkingDays = () => {
    console.log("daysMaster", daysMaster);
    const selectedIds = daysMaster
      .filter((day) => selectedDays.includes(day.dayName))
      .map((day) => day.dayId);

    const originalWorkingDays = fullData?.calendarWorkingDays || [];
    const originalIds = originalWorkingDays.map((day: any) => day.dayId);

    const newLines = selectedIds
      .filter((id) => !originalIds.includes(id))
      .map((id) => ({ dayId: id }));

    const deletedLines = originalWorkingDays
      .filter((day: any) => !selectedIds.includes(day.dayId))
      .map((day: any) => ({ workingDayId: day.workingDayId }));

    return {
      newLines,
      updatedLines: [],
      deletedLines,
    };
  };
  const getShiftTimeValues = (values: Record<string, any>) => {
    const timeMap: Record<string, { startTime: string; endTime: string }> = {};

    Object.keys(values).forEach((key) => {
      if (key.startsWith("startTime-") || key.startsWith("endTime-")) {
        const shiftName = key.split("-")[1];
        if (!timeMap[shiftName]) {
          timeMap[shiftName] = { startTime: "", endTime: "" };
        }

        const val = values[key];

        let formattedTime = "";
        if (val) {
          if (typeof val === "object" && typeof val.format === "function") {
            formattedTime = val.format("HH:mm:ss"); // handles dayjs object
          } else if (typeof val === "string") {
            formattedTime = val; // already formatted string
          }
        }

        if (key.startsWith("startTime-")) {
          timeMap[shiftName].startTime = formattedTime;
        } else {
          timeMap[shiftName].endTime = formattedTime;
        }
      }
    });

    return timeMap;
  };

  const formatCalendarShiftsPayload = () => {
    const values = formMethods.getValues();
    const timeMap = getShiftTimeValues(values); // from previous message

    const newLines: any[] = [];
    const updatedLines: any[] = [];
    const deletedLines: any[] = [];

    const originalNames = originalShifts.map((s: any) => s.name);
    const currentSelected = selectedShifts;

    // 1. Check deleted
    originalShifts.forEach((original: any) => {
      if (!currentSelected.includes(original.name)) {
        console.log("deleted", original);
        deletedLines.push({ shiftId: original.shiftId }); // deselected shift
      }
    });

    // 2. Check updated or unchanged
    originalShifts.forEach((original: any) => {
      if (currentSelected.includes(original.name)) {
        const time = timeMap[original.name];
        if (
          time &&
          (time.startTime !== original.shiftStartTime ||
            time.endTime !== original.shiftEndTime)
        ) {
          updatedLines.push({
            shiftId: original.shiftId,
            shiftName: original.name,
            shiftType: original.shiftType || "Others",
            shiftStartTime: time.startTime,
            shiftEndTime: time.endTime,
          });
        }
      }
    });

    // 3. Check newly added
    shifts.forEach((shift) => {
      if (
        !originalNames.includes(shift.name) &&
        currentSelected.includes(shift.name)
      ) {
        const time = timeMap[shift.name];
        if (time?.startTime && time?.endTime) {
          newLines.push({
            shiftType: "Others",
            shiftName: shift.name,
            shiftStartTime: time.startTime,
            shiftEndTime: time.endTime,
          });
        }
      }
    });

    return {
      calendarShifts: {
        newLines,
        updatedLines,
        deletedLines,
      },
    };
  };

  const toggleShiftSelection = (shiftName: string) => {
    const updated = selectedShifts.includes(shiftName)
      ? selectedShifts.filter((s) => s !== shiftName)
      : [...selectedShifts, shiftName];
    setSelectedShifts(updated);
  };

  const addNewShift = () => {
    const normalized = newShiftName.trim().toLowerCase();
    const isDuplicate = shifts.some(
      (s) => s.name.trim().toLowerCase() === normalized
    );

    if (newShiftName.trim() && !isDuplicate) {
      setShifts([...shifts, { name: newShiftName.trim() }]);
      setSelectedShifts([...selectedShifts, newShiftName.trim()]);
      setNewShiftName("");
      setPopoverVisible(false);
    } else if (isDuplicate) {
      message.warning("Shift name already exists!");
    }
  };

  const columns: any = [
    { title: "Holiday Name", dataIndex: "holidayName", key: "holidayName" },
    {
      title: "Holiday Date",
      dataIndex: "holidayDate",
      key: "holidayDate",
      render: (text: any) => {
        return text && dayjs(text).format("DD-MMM-YYYY");
      },
    },
    ...(isEditMode
      ? [
          {
            title: "Actions",
            key: "actions",
            render: (text: any, record: any) => (
              <a
                style={{ cursor: "pointer", color: "#1890ff" }}
                onClick={() => handleEditHoliday(record)}
              >
                Edit
              </a>
            ),
          },
        ]
      : []),
  ];

  const handleEditHoliday = (holiday: any) => {
    // Set the holiday data to the modal
    formMethods.setValue("holidayName", holiday.holidayName);
    formMethods.setValue("holidayDate", dayjs(new Date(holiday.holidayDate)));
    setSelectedHolidayId(holiday.holidayId); // Keep track of the holiday being edited
    setModalVisible(true); // Show the modal
  };

  const handleSaveHoliday = () => {
    console.log("data", selectedHolidayId);
    const updatedName = formMethods.getValues("holidayName");
    const updatedDate = formMethods.getValues("holidayDate");
    if (selectedHolidayId) {
      // Edit the existing holiday
      const updatedHoliday = {
        holidayId: selectedHolidayId,
        holidayName: updatedName,
        holidayDate: updatedDate ? dayjs(updatedDate).format("YYYY-MM-DD") : updatedDate,
      };

      // Update logic (e.g., call an API or update local state)
      updateHoliday(updatedHoliday);
    } else {
      // Add new holiday
      const newHoliday = {
        holidayId: nanoid(),
        holidayName,
        holidayDate: dateRange,
      };

      // Add logic (e.g., call an API or update local state)
      addHoliday(newHoliday);
    }

    // Close modal after saving
    setModalVisible(false);
    resetHolidayForm();
    setSelectedHolidayId(null);
    setDateRange("");
    setHolidayName("");
  };

  const addHoliday = (holiday: any) => {
    setHolidayState((prev: any) => ({
      ...prev,
      newLines: [...prev.newLines, holiday],
    }));
  };

  const updateHoliday = (holiday: any) => {
    const holidayId = holiday.holidayId;
    const updatedFields = {
      holidayName: holiday.holidayName,
      holidayDate: holiday.holidayDate,
    };
    setHolidayState((prev: any) => {
      const inNew = prev.newLines.find((h: any) => h.holidayId === holidayId);
      const inUpdated = prev.updatedLines.find(
        (h: any) => h.holidayId === holidayId
      );
      const inExisting = prev.existing.find(
        (h: any) => h.holidayId === holidayId
      );

      if (inNew) {
        return {
          ...prev,
          newLines: prev.newLines.map((h: any) =>
            h.holidayId === holidayId ? { ...h, ...holiday } : h
          ),
        };
      }

      if (inUpdated) {
        return {
          ...prev,
          updatedLines: prev.updatedLines.map((h: any) =>
            h.holidayId === holidayId ? { ...h, ...holiday } : h
          ),
        };
      }

      if (inExisting) {
        return {
          ...prev,
          updatedLines: [
            ...prev.updatedLines.filter((h: any) => h.holidayId !== holidayId),
            holiday,
          ],
        };
      }

      return prev;
    });
  };

  const resetHolidayForm = () => {
    setHolidayName("");
    formMethods.setValue("holidayName", "");
    setDateRange("");
    formMethods.setValue("holidayDate", null);
    setSelectedHolidayId(null);
  };

  const onSubmit = (data: any) => {
    setLoading(true);
    console.log("data::SUBMIT", data);
    const payload: any = {};
    const updatedHolidayNewLines = holidayState.newLines.map((holiday: any) => {
      const { holidayId, ...rest } = holiday; // Destructure to remove holidayId
      return rest; // Return the holiday object without the `holidayId`
    });
    const holidays = {
      newLines: updatedHolidayNewLines,
      updatedLines: holidayState.updatedLines,
      deletedLines: holidayState.deletedLines,
    };
    if (
      holidays.newLines.length ||
      holidays.updatedLines.length ||
      holidays.deletedLines.length
    ) {
      payload.calendarHolidays = holidays;
    }
    const workingDays = prepareCalendarWorkingDays();
    if (
      workingDays.newLines.length ||
      workingDays.updatedLines.length ||
      workingDays.deletedLines.length
    ) {
      payload.calendarWorkingDays = workingDays;
    }
    const shifts = formatCalendarShiftsPayload().calendarShifts;
    if (
      shifts.newLines.length ||
      shifts.updatedLines.length ||
      shifts.deletedLines.length
    ) {
      payload.calendarShifts = shifts;
    }

    console.log("payload", payload);
    updatecalender(payload);
  };

  const hasFormLevelChanges = () => {
    return (
      !!dirtyFields?.calendarTitle ||
      !!dirtyFields?.calendarStartDate ||
      !!dirtyFields?.calendarEndDate
    );
  };

  const updatecalender = async (payload: any) => {
    console.log("payload", payload);
    if (hasFormLevelChanges()) {
      const values = getValues();
      console.log("hasFormLevelChanges", hasFormLevelChanges());
      if (dirtyFields?.calendarTitle) {
        payload.calendarTitle = values.calendarTitle;
      }

      if (dirtyFields?.calendarStartDate) {
        payload.calendarStartDate = dayjs(values.calendarStartDate).format(
          "YYYY-MM-DD"
        );
      }

      if (dirtyFields?.calendarEndDate) {
        payload.calendarEndDate = dayjs(values.calendarEndDate).format(
          "YYYY-MM-DD"
        );
      }
    }
    payload.calendarId = fullData.calendarId;
    try {
      const response: ApiResponse = await calendarApis.updateCalendar(payload);
      const { data, status, message, error } = response || {};
      if (status) {
        Swal.fire({
          icon: "success",
          title: "Updated Successfully",
          text: data?.message,
          confirmButtonText: "Ok",
        });
        refresh();
        // fetchDataById(id);
      } else {
        setWarning({
          message,
          error,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const deactivateCalendar = async () => {
    try {
      const response: ApiResponse = await calendarApis.inactivateCalendar(
        fullData?.calendarId
      );
      const { data, status, message, error } = response || {};
      if (status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data?.message,
          confirmButtonText: "Ok",
        });
        // fetchDataById(id);
        refresh();
      } else {
        setWarning({
          message,
          error,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const activateCalendar = async () => {
    try {
      const response: ApiResponse = await calendarApis.activateCalendar(
        fullData?.calendarId
      );
      const { data, status, message, error } = response || {};
      if (status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data?.message,
          confirmButtonText: "Ok",
        });
        // fetchDataById(id);
        refresh();
      } else {
        setWarning({
          message,
          error,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Flex align="center" gap="middle" className="pageLoader">
        <Spin
          indicator={<LoadingOutlined spin />}
          className="m-auto"
          size="large"
        />
      </Flex>
    );
  }
  if (!loading && !fullData) {
    return (
      <Result
        status="500"
        title="500"
        subTitle="Sorry, something went wrong."
        extra={
          <Button
            className="btn btn-primary btn-sm"
            // type="button"
            color="primary"
            onClick={() => {
              refresh();
              // close();
            }}
          >
            <Icon name={"arrow-left"} />
            <span>Back</span>
          </Button>
        }
      />
    );
  }

  const resettingFields = (fullData: any) => {
    const { calendarTitle, calendarStartDate, calendarEndDate } = fullData;
    reset({
      calendarTitle: calendarTitle,
      calendarStartDate: dayjs(new Date(calendarStartDate)),
      calendarEndDate: dayjs(new Date(calendarEndDate)),
    });
    setLoading(false);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex justify-content-between align-items-center mt-2">
          <h5 className="w-100 d-flex  align-items-center"></h5>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <Alert
            isOpen={fullData?.status == "Inactive"}
            color="danger"
            className="start-0 w-100 py-1 mt-2"
            style={{
              top: 0,
              textAlign: "left",
              fontSize: "14px",
              cursor: "default",
            }}
          >
            <span className="fw-bold">Inactive:</span>{" "}
            <ReactTyped
              strings={[
                `This calendar is currently inactive. Last updated on ${dayjs(
                  fullData?.updatedAt
                ).format("DD-MMM-YYYY")} by "${
                  fullData?.updatedByUserName || "N/A"
                }".`,
              ]}
              typeSpeed={5}
              showCursor={false}
            />
          </Alert>

          <Alert
            isOpen={warning?.message != undefined}
            color="danger"
            className="start-0 w-100 py-1 mt-2"
            style={{
              top: 0,
              textAlign: "left",
              fontSize: "14px",
              cursor: "default",
            }}
          >
            <span className="fw-bold">{warning?.error}: </span>
            <ReactTyped
              strings={[warning?.message || ""]}
              typeSpeed={10}
              showCursor={false}
            />
          </Alert>
          <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2 pe-2 ms-auto">
            {!isEditMode && (
              <>
                <li>
                  <ViewAccess moduleName="Calendar">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        tag="a"
                        className="dropdown-toggle btn btn-icon btn-trigger"
                      >
                        <Icon name="more-v"></Icon>
                      </DropdownToggle>
                      <DropdownMenu end>
                        <ul className="link-list-opt">
                          {/* no-bdr */}
                          {fullData?.status == "Active" && (
                            <li>
                              <DropdownItem
                                tag="a"
                                href="#tableView"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  setIsEditMode(true);
                                }}
                              >
                                <span>Edit </span>
                              </DropdownItem>
                            </li>
                          )}
                          {fullData?.status == "Active" && (
                            <li>
                              <DropdownItem
                                tag="a"
                                href="#cardView"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  deactivateCalendar();
                                }}
                              >
                                <span>Deactivate</span>
                              </DropdownItem>
                            </li>
                          )}
                          {fullData?.status !== "Active" && (
                            <li>
                              <DropdownItem
                                tag="a"
                                href="#detailView"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  activateCalendar();
                                }}
                              >
                                <span>Activate</span>
                              </DropdownItem>
                            </li>
                          )}
                        </ul>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </ViewAccess>
                </li>
              </>
            )}
            {isEditMode && (
              <>
                <li>
                  <Button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    color="primary"
                    htmlType="submit"
                    style={{ marginBottom: "20px" }}
                  >
                    <Icon name={"save"} />
                    <span>Save</span>
                  </Button>
                </li>
                <li>
                  <Button
                    className="btn btn-secondary btn-sm"
                    type="button"
                    color="secondary"
                    onClick={() => {
                      setLoading(true);
                      setIsEditMode(false);
                      resettingFields(fullData);
                    }}
                    style={{ marginBottom: "20px" }}
                  >
                    <span>Cancel</span>
                  </Button>
                </li>
              </>
            )}
          </ul>
        </div>
        <div className="nk-wizard nk-wizard-simple is-alter wizard clearfix">
          <FormProvider {...formMethods}>
            <div>
              <Row className="gy-4">
                <Col lg="4">
                  <div className="data-col align-center pt-1">
                    <div className="data-label w-30">
                      Calendar Title
                      {isEditMode && <span className="mandatory m-1">*</span>}
                    </div>
                    <div className="data-value w-70">
                      {isEditMode ? (
                        <FormInput
                          name="calendarTitle"
                          required={false}
                          hideRequiredMark={true}
                          label={""}
                          placeholder="Enter Calendar Title"
                        />
                      ) : (
                        <>{watch("calendarTitle")}</>
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="data-col align-center pt-1">
                    <div className="data-label w-30">
                      Start Date
                      {isEditMode && <span className="mandatory m-1">*</span>}
                    </div>
                    <div className="data-value w-70">
                      {isEditMode ? (
                        <FormDatePicker
                          name="calendarStartDate"
                          label={""}
                          hideRequiredMark={true}
                          required={true}
                          minDate={new Date()}
                        />
                      ) : (
                        <div>
                          {watch("calendarStartDate")
                            ? dayjs(watch("calendarStartDate"))?.format(
                                "DD-MMM-YYYY"
                              )
                            : "-"}
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="data-col align-center pt-1">
                    <div className="data-label w-30">
                      End Date
                      {isEditMode && <span className="mandatory m-1">*</span>}
                    </div>
                    <div className="data-value w-70">
                      {isEditMode ? (
                        <FormDatePicker
                          name="calendarEndDate"
                          label={""}
                          hideRequiredMark={true}
                          required={true}
                          minDate={new Date()}
                        />
                      ) : (
                        <div>
                          {watch("calendarEndDate")
                            ? dayjs(watch("calendarEndDate"))?.format(
                                "DD-MMM-YYYY"
                              )
                            : "-"}
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              <Col lg="8" className="mt-4">
                {/* <div className="data-col align-center pt-1"> */}
                <label
                  className="mb-2"
                  style={{ color: "black", fontWeight: 500 }}
                >
                  Setup Working Days
                  {isEditMode && <span className="mandatory">*</span>}
                </label>
                <Segmented
                  options={daysMaster.map((day) => ({
                    label: (
                      <span
                        style={{
                          color: selectedDays.includes(day.dayName)
                            ? "#f3f3f3"
                            : "black",
                        }}
                      >
                        {day.dayName}
                      </span>
                    ),
                    value: day.dayName,
                    className: selectedDays.includes(day.dayName)
                      ? "selected-segment"
                      : "",
                  }))}
                  value={selectedDays}
                  onChange={toggleSelection}
                  block
                  multiple
                  disabled={!isEditMode}
                />
                {/* </div> */}
              </Col>

              <Col lg={8} className="mt-4">
                <Row>
                  <Col>
                    <label
                      className="mb-2"
                      style={{ color: "black", fontWeight: 500 }}
                    >
                      Setup Working Hours
                    </label>
                  </Col>
                  {isEditMode && (
                    <Col lg={2}>
                      <Popover
                        content={
                          <div style={{ display: "flex", gap: "10px" }}>
                            <Input
                              placeholder="Shift Name"
                              value={newShiftName}
                              onChange={(e) => setNewShiftName(e.target.value)}
                            />
                            <Button onClick={addNewShift}>Save</Button>
                          </div>
                        }
                        title="Add New Shift"
                        trigger="click"
                        open={popoverVisible}
                        onOpenChange={setPopoverVisible}
                      >
                        <a style={{ cursor: "pointer", color: "#1890ff" }}>
                          + Add Shift
                        </a>
                      </Popover>
                    </Col>
                  )}
                </Row>

                {(isEditMode ? shifts : fullData?.calendarShifts || []).map(
                  (shift: any) => (
                    <Row
                      key={shift.name || shift.shiftName}
                      style={{ marginBottom: "10px" }}
                    >
                      <Col span={6}>
                        <Checkbox
                          checked={
                            isEditMode
                              ? selectedShifts.includes(shift.name)
                              : true // all are shown in view mode
                          }
                          disabled={!isEditMode}
                          onChange={() =>
                            isEditMode &&
                            toggleShiftSelection(shift.name || shift.shiftName)
                          }
                        >
                          {shift.name || shift.shiftName}
                        </Checkbox>
                      </Col>

                      {(isEditMode
                        ? selectedShifts.includes(shift.name)
                        : true) && ( // always show in view
                        <>
                          <Col span={8}>
                            {isEditMode ? (
                              <FormTimePicker
                                name={`startTime-${shift.name}`}
                                label={""}
                                placeholder="Start Time"
                                required={true}
                                // defaultValue={
                                //   shift.shiftStartTime
                                //     ? dayjs(shift.shiftStartTime, "HH:mm")
                                //     : undefined
                                // }
                              />
                            ) : (
                              <div className="">
                                <strong>Start:</strong> {shift.shiftStartTime}
                              </div>
                            )}
                          </Col>
                          <Col span={8}>
                            {isEditMode ? (
                              <FormTimePicker
                                name={`endTime-${shift.name}`}
                                label={""}
                                placeholder="End Time"
                                required={true}
                                // defaultValue={
                                //   shift.shiftEndTime
                                //     ? dayjs(shift.shiftEndTime, "HH:mm")
                                //     : undefined
                                // }
                              />
                            ) : (
                              <div className="">
                                <strong>End:</strong> {shift.shiftEndTime}
                              </div>
                            )}
                          </Col>
                        </>
                      )}
                    </Row>
                  )
                )}
              </Col>
            </div>

            <div>
              {/* Label with "Add Holiday" Button */}
              <Row
                justify="space-between"
                // align="middle"
                style={{ marginTop: "15px" }}
              >
                <Col>
                  <label className="form-label">Setup Holidays</label>
                </Col>
                {isEditMode && (
                  <Col style={{ justifyContent: "end", display: "flex" }}>
                    <a
                      style={{
                        cursor: "pointer",
                        color: "#1890ff",
                      }}
                      onClick={() => {
                        setSelectedHolidayId(null);
                        setModalVisible(true);
                        setDateRange("");
                        setHolidayName("");
                      }}
                    >
                      + Add Holiday
                    </a>
                  </Col>
                )}
              </Row>

              {/* Ant Design Table */}
              <Table
                rowKey={(record) =>
                  record.holidayId ||
                  `${record.holidayName}-${record.holidayDate}`
                }
                dataSource={holidays}
                columns={columns}
                bordered
                pagination={pagination}
              />

              {/* Add Holiday Modal */}
              <Modal
                title="Add Holiday"
                isOpen={modalVisible}
                className="modal-dialog-centered"
                toggle={() => setModalVisible(false)}
                backdrop="static"
                // onOk={handleSaveHoliday}
              >
                <a
                  href="#dropdownitem"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setModalVisible(false);
                    resetHolidayForm();
                  }}
                  className="close"
                >
                  <Icon name="cross-sm"></Icon>
                </a>
                <ModalBody>
                  <div className="nk-modal-head mb-3">
                    <h5 className="title">Set Holiday </h5>
                  </div>
                  {/* <form onSubmit={handleSubmit(onSubmitHoliday)}> */}
                  <div style={{ marginBottom: "15px" }}>
                    <FormInput
                      name="holidayName"
                      label="Holiday Name"
                      required={true}
                      type="text"
                      placeholder="Enter Holiday Name"
                      defaultValue={holidayName}
                      onInput={(value: any) => {
                        // console.log("value", value.target.value);
                        setHolidayName(value.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <FormDatePicker
                      name="holidayDate"
                      label="Holiday Date"
                      required={true}
                      placeholder="Select Holiday Date"
                      defaultValue={dateRange}
                      onChange={(value: any) => {
                        setDateRange(dayjs(value).format("YYYY-MM-DD"));
                      }}
                    />
                  </div>
                  <Row className="gy-4 mt-2">
                    <Col>
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button
                            color="primary"
                            // size="lg"
                            onClick={() => handleSaveHoliday()}
                            // type="submit"
                          >
                            Save
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#dropdownitem"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setModalVisible(false);
                              setSelectedHolidayId(null);
                              setDateRange("");
                              setHolidayName("");
                              resetHolidayForm();
                            }}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                  {/* </form> */}
                </ModalBody>
              </Modal>
            </div>

            {/* <div style={{ marginTop: 24 }}>
            {!isEditMode && (
              <Button color="default" onClick={() => setIsEditMode(true)}>
                Edit
              </Button>
            )}
            {isEditMode && (
              <Button color="primary" htmlType="submit" disabled={!formIsDirty}>
                Save
              </Button>
            )}
          </div> */}
          </FormProvider>
        </div>
      </form>
    </>
  );
};

export default CalendarView;
